import { Component, Input } from '@angular/core';
import { ExerciseActivityTypeEnum } from '@therapist/shared/models/exercise/exercise-template.dto';

@Component({
  selector: 'sana-tp-exercise-activity-badge',
  imports: [],
  templateUrl: './exercise-activity-badge.component.html',
  styleUrl: './exercise-activity-badge.component.scss'
})
export class ExerciseActivityBadgeComponent {

  @Input({ required: true }) activityType!: ExerciseActivityTypeEnum;

  protected readonly ExerciseActivityTypeEnum = ExerciseActivityTypeEnum;
}
